import keys from '@debbie/common/dist/cache/keys.js';
import { Direction, InteractionType, OutgoingState, } from '@debbie/common/dist/interactions/index.js';
import * as interactions from '../api/interactions.js';
import { interactionsEntity } from '../interactions/index.js';
import q from '../query.js';
import { resetInteraction, setInteraction } from './index.js';
export const sendNote = async (referenceId, referenceType, options, note, uploadedFiles, minVisibilityRole, details = {}) => {
    setInteraction(referenceId, 'note', (v) => ({ ...v, loading: true }));
    try {
        await interactions.create({
            referenceType,
            referenceId,
            templateId: note.templateId || null,
            direction: options.direction,
            state: OutgoingState.SENT,
            type: options.type,
            attachments: uploadedFiles.map((f) => f.fileId),
            details,
            minVisibilityRole,
            notes: note.content,
        });
        q.invalidate(keys.write.create(interactionsEntity));
        resetInteraction(referenceId, 'note');
        resetInteraction(referenceId, 'uploadedFiles');
    }
    finally {
        setInteraction(referenceId, 'note', (v) => ({ ...v, loading: false }));
    }
};
export const sendEmail = async (referenceId, referenceType, templateId, details, attachments, minVisibilityRole, intent, replyingToInteractionId) => {
    setInteraction(referenceId, 'email', (v) => ({ ...v, loading: true }));
    try {
        await interactions.create({
            referenceType,
            referenceId,
            templateId: templateId || null,
            direction: Direction.OUTGOING,
            state: OutgoingState.SENT,
            type: InteractionType.Email,
            details,
            attachments,
            minVisibilityRole,
            intent,
            replyingToInteractionId: replyingToInteractionId ?? undefined,
        });
        q.invalidate(keys.write.create(interactionsEntity));
        resetInteraction(referenceId, 'email');
        resetInteraction(referenceId, 'uploadedFiles');
    }
    finally {
        setInteraction(referenceId, 'email', (v) => ({ ...v, loading: false }));
    }
};
export const sendLetter = async (referenceId, referenceType, templateId, letterBody, attachments, minVisibilityRole, address, intent) => {
    setInteraction(referenceId, 'letter', (v) => ({ ...v, loading: true }));
    try {
        await interactions.create({
            referenceId,
            referenceType,
            templateId: templateId || null,
            direction: Direction.OUTGOING,
            state: OutgoingState.QUEUED,
            type: InteractionType.Letter,
            details: {
                address,
                body: letterBody,
            },
            attachments,
            minVisibilityRole,
            intent,
        });
        q.invalidate(keys.write.create(interactionsEntity));
        resetInteraction(referenceId, 'letter');
        resetInteraction(referenceId, 'uploadedFiles');
    }
    finally {
        setInteraction(referenceId, 'letter', (v) => ({ ...v, loading: false }));
    }
};
export const sendEBoks = async (referenceId, referenceType, templateId, pdfBody, eBoksTitle, attachments, minVisibilityRole, intent, recipient) => {
    setInteraction(referenceId, 'eboks', (v) => ({ ...v, loading: true }));
    try {
        await interactions.create({
            referenceId,
            referenceType,
            templateId: templateId || null,
            direction: Direction.OUTGOING,
            state: OutgoingState.SENT,
            type: InteractionType.Eboks,
            details: {
                body: pdfBody,
                recipient,
                title: eBoksTitle,
            },
            minVisibilityRole,
            attachments,
            intent,
        });
        q.invalidate(keys.write.create(interactionsEntity));
        resetInteraction(referenceId, 'eboks');
        resetInteraction(referenceId, 'uploadedFiles');
    }
    finally {
        setInteraction(referenceId, 'eboks', (v) => ({ ...v, loading: false }));
    }
};
export const registerPhoneCall = async (referenceId, referenceType, phone, minVisibilityRole) => {
    setInteraction(referenceId, 'phone', (v) => ({ ...v, loading: true }));
    try {
        await interactions.create({
            referenceId,
            referenceType,
            direction: phone.direction,
            state: OutgoingState.SENT,
            type: InteractionType.Phone,
            notes: phone.content,
            details: {
                phone: phone.phone,
                tags: phone.tags,
            },
            minVisibilityRole,
        });
        q.invalidate(keys.write.create(interactionsEntity));
        resetInteraction(referenceId, 'phone');
        resetInteraction(referenceId, 'uploadedFiles');
    }
    finally {
        setInteraction(referenceId, 'phone', (v) => ({ ...v, loading: false }));
    }
};
export const sendSMS = async (referenceId, referenceType, sms, details, minVisibilityRole, intent) => {
    setInteraction(referenceId, 'sms', (v) => ({ ...v, loading: true }));
    try {
        await interactions.create({
            referenceId,
            referenceType,
            templateId: sms.templateId || null,
            direction: Direction.OUTGOING,
            state: OutgoingState.SENT,
            type: InteractionType.SMS,
            details,
            minVisibilityRole,
            intent,
        });
        q.invalidate(keys.write.create(interactionsEntity));
        resetInteraction(referenceId, 'sms');
        resetInteraction(referenceId, 'uploadedFiles');
    }
    finally {
        setInteraction(referenceId, 'sms', (v) => ({ ...v, loading: false }));
    }
};
export const registerAutoCall = async (referenceId, referenceType, autocall, details, minVisibilityRole) => {
    setInteraction(referenceId, 'autocall', (v) => ({ ...v, loading: true }));
    try {
        await interactions.create({
            referenceId,
            referenceType,
            templateId: autocall.templateId || null,
            direction: Direction.OUTGOING,
            state: OutgoingState.SENT,
            type: InteractionType.AutoCall,
            details,
            minVisibilityRole,
        });
        q.invalidate(keys.write.create(interactionsEntity));
        resetInteraction(referenceId, 'autocall');
        resetInteraction(referenceId, 'uploadedFiles');
    }
    finally {
        setInteraction(referenceId, 'autocall', (v) => ({ ...v, loading: false }));
    }
};
//# sourceMappingURL=actions.js.map